import React, { useEffect, useState } from "react";
import ReverifyProperty from "../PropertyView/ReverifyProperty";
import ReverifyDetails from "../PropertyView/ReverifyDetails";
import ReverifyRooms from "../PropertyView/ReverifyRooms";
import DocumentReverificationTab from "../PropertyView/DocumentReverificationTab";
import { useLocation } from "react-router-dom";
import FollowUp from "../../screens/Property/FollowUp";

const PropertyReverificationView = () => {
  const location = useLocation();
  const [tabs, setTabs] = useState(1);
  const data = location.state
  const value = data?.data?.property_type



  return (
    <div className="dashRightView home_section">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec ">
          Reverification View
        </h2>
      </div>
      <div className='d-flex gap-4 mt-3'>
        <h2 onClick={() => { setTabs(1) }} className={`${tabs == 1 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Property
        </h2>
        <h2 onClick={() => { setTabs(2) }} className={`${tabs == 2 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Details
        </h2>
        {value == 1 && (
          <h2 onClick={() => { setTabs(3) }} className={`${tabs == 3 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
            Rooms
          </h2>
        )}
        <h2 onClick={() => { setTabs(4); }} className={`${tabs == 4 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`} >
          Document Verification
        </h2>

        <h2 onClick={() => { setTabs(5) }} className={`${tabs == 5 ? "active_tabs" : ""} f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 primary pointer`}>
          Follow Ups
        </h2>
      </div>

      {tabs == 1 && (
        <ReverifyProperty data={data} />
      )}
      {tabs == 2 && (
        <ReverifyDetails data={data} setTabs={setTabs} />
      )}
      {tabs == 3 && <ReverifyRooms data={data} setTabs={setTabs} />}
      {tabs == 4 && <DocumentReverificationTab data={data} setTabs={setTabs} value={value} />}
      {tabs == 5 && <FollowUp data={data} />}
    </div>
  );
};

export default PropertyReverificationView